import { coverflow_data } from "@/data/coverflow_data";
import { apiGet, apiGetPromise } from "@/helper/api";
import moment from "moment";
import { useState } from "react";

const useAuctions = () => {
  const [auctionsData, setAuctionsData] = useState([]);
  const [loadMoreBtn, setLoadMoreBtn] = useState(true);
  const getAuctionsData = (page) => {
    apiGetPromise(
      `/data/Collection?pageSize=4&offset=${page ?? 0}&where=isAuction%3Dtrue&loadRelations=collectionTags%2CcollectionAttributes.collectionAttributeValues.collectionAttributeValueUtilities%2CcollectionAttributes%2CcollectionAttributes.collectionAttributeValues%2CcommunityOwner`
    ).then((res) => {
     if(res.length === 0) {
      setLoadMoreBtn(false)
     }
     else {
      setLoadMoreBtn(true)
     }
       const auctions =  res?.map((item) => 
       { 
        const min = 0.01;
        const max = 3.0;
        const randomNum = (Math.random() * (max - min) + min).toFixed(2);
  
        return {
          ...item,
          id: item?.objectId,
          bigImage: item?.image,
          title: item?.name,
          creatorImage: item?.communityOwner?.profileImage,
          creatorName: item?.communityOwner?.name,
          ownerImage: "/images/avatars/owner_1.png",
          price: `${randomNum} ETH`,
          auction_timer: item?.auctionEndTime ? moment.unix(item?.auctionEndTime / 1000)._d : Date.now(),
        }})
        if(page){
          setAuctionsData([...auctionsData,...auctions])
        }else {
          setAuctionsData(auctions ?? [])
        }
        
    
    });
  };

  return { getAuctionsData, auctionsData ,loadMoreBtn};
};

export default useAuctions;
